import PropTypes from 'prop-types';
// @mui
import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { grey } from 'src/theme/palette';

const CampaignNoData = ({ isNotFound, type }) => {
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    return (
        <Box sx={{ width: '100%' }}>
            {isNotFound && (
                <Box sx={{ bgcolor: isLight ? grey[200] : alpha(grey[500], 0.12), borderRadius: 2, border: `1px dashed ${alpha(grey[500], 0.32)}` }}>
                    <Box sx={{ display: 'flex', py: 4, px: 3, flexDirection: 'column', alignItems: 'center' }}>
                        <img src='/assets/no-script.png' alt='no-appointment' style={{ maxHeight: '160px', maxWidth: '200px', objectFit: 'contain' }} />
                        <Typography variant="subtitle1" sx={{ textAlign: 'center', color: isLight ? grey[800] : '#fff', fontWeight: 700, mt: 2 }}>
                            {type === 'campaignReport' ? 'No data' : 'No campaigns'}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

CampaignNoData.propTypes = {
    isNotFound: PropTypes.bool,
    type: PropTypes.string
};

export default CampaignNoData;
